import { Link } from "react-router-dom"

function TileFlip({ className, naslov, ikonica, boja: pozadina, poruka, link, width = '100%', height = '100%', bojaNaslova, bojaIvice }) {
    let divStyle = {
        outline: `solid 2px`,
        outlineColor: bojaIvice,
        background: pozadina
    }

    let isExternalLink = false;
    let internalPath = link;

    if (link && (link.startsWith('http://') || link.startsWith('https://'))) {
        try {
            const linkUrl = new URL(link);
            const currentHost = window.location.host;
            if (linkUrl.host === currentHost) {
                internalPath = linkUrl.pathname + linkUrl.search + linkUrl.hash;
                isExternalLink = false;
            } else {
                isExternalLink = true;
            }
        } catch (e) {
            isExternalLink = true;
        }
    }

    const content = (
        <>
            <div className="back" style={{ background: pozadina }}>
                <div className="tile-flip-poruka" dangerouslySetInnerHTML={{ __html: poruka }}></div>
            </div>
            <div style={divStyle} className="front">
                <p style={{ color: bojaNaslova }} className="tile-flip-naslov">{naslov}</p>
                <img src={ikonica}></img>
            </div>
        </>
    );

    return <div className={`flipbox ${className}`} style={{ width: width, height: height }}>
        {isExternalLink ? (
            <a href={link} className="tile-flip" target="_blank" rel="noopener noreferrer">
                {content}
            </a>
        ) : (
            <Link to={internalPath} className="tile-flip">
                {content}
            </Link>
        )}
    </div>
}

export default TileFlip